"use client";

var __jsx = React.createElement;
import { useBenefitLogin } from "@lib/context/shared/benefit-iframe-context";
import { MuscleButton } from "@modules/shared/components/buttons";
import { useTranslations } from "next-intl";
import React from "react";
const BenefitLoginButton = _ref => {
  let {
    className,
    src
  } = _ref;
  const {
    openBenefitLogin
  } = useBenefitLogin();
  const t = useTranslations("Shared");
  return __jsx(MuscleButton, {
    className: className,
    onClick: () => openBenefitLogin(),
    variant: "solidLg"
  }, t("LANDING_PAGE.LANDING_BUTTON"), __jsx("div", {
    className: "w-full h-full max-w-[81px] max-h-[16px]"
  }, __jsx("img", {
    src: src,
    alt: "Logo",
    className: "object-contain"
  })));
};
export default BenefitLoginButton;